export const isFieldRequired = (formSchema, fieldName, formValues) => {
	const fieldValidation = formSchema?.fields[fieldName]

	if (!fieldValidation) {
		return false
	}

	try {
		const resolvedField = fieldValidation.resolve({
			parent: formValues,
			value: formValues[fieldName],
		})

		return resolvedField?.tests?.some(test => test.OPTIONS.name === 'required')
	} catch (error) {
		return false
	}
}